/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import css from './toast.scss';
import ban from '../../assets/images/Ban.svg';
import CloseButton from '../close-button/close-button';
import toastActions from './toast-actions';

class Toast extends Component {
    static propTypes = {
        messageData: PropTypes.shape({
            message: PropTypes.string,
            type: PropTypes.string,
            hasClose: PropTypes.bool
        }),
        clearToastData: PropTypes.func
    }

    constructor(props) {
        super(props);
        const { message, type, hasClose } = props.messageData;
        this.state = {
            messageData: props.messageData,
            baseClass: 'toast',
            toastClasses: css.toast,
            toastSequence: 'start',
            toastMessage: message,
            toastType: type,
            toastReady: false,
            hasClose
        };
    }

    componentDidMount() {
        const { toastSequence, baseClass, toastType } = this.state;
        if (toastSequence === 'start') {
            const showToastTimer = setTimeout(() => {
                this.setState({
                    toastClasses: `${css[baseClass]} ${css[toastType]} ${css.show}`
                });
                clearTimeout(showToastTimer);
                this.setState({
                    toastSequence: 'fade'
                });
            }, 500);
        }
    }

    componentDidUpdate() {
        const { toastSequence, baseClass, toastType } = this.state;
        const { clearToastData } = this.props;

        if (toastSequence === 'fade') {
            const fadeToastTimer = setTimeout(() => {
                this.setState({
                    toastClasses: `${css[baseClass]} ${css[toastType]} ${css.hide}`
                });
                clearTimeout(fadeToastTimer);
                this.setState({
                    toastSequence: 'remove'
                });
            }, 3000);
        }
        if (toastSequence === 'close') {
            const fadeToastTimer = setTimeout(() => {
                this.setState({
                    toastClasses: `${css[baseClass]} ${css[toastType]} ${css.hide}`
                });
                clearTimeout(fadeToastTimer);
                this.setState({
                    toastSequence: 'remove'
                });
            }, 200);
        }
        if (toastSequence === 'remove') {
            const removeToastTimer = setTimeout(() => {
                clearTimeout(removeToastTimer);
                clearToastData();
            }, 3000);
        }
    }

    onClose = () => {
        this.setState({
            toastSequence: 'close'
        });
    };

    render() {
        const { toastClasses, toastMessage, hasClose } = this.state;

        return (
            <div className={css['toast-holder']}>
                <div className={toastClasses}>
                    <div className={css.message}>
                        <Isvg src={ban} className={css.icon} />
                        <div className={css.text}>{toastMessage}</div>
                        {hasClose &&
                        <CloseButton onClose={this.onClose} className={css['close-button']} />
                        }
                    </div>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        clearToastData: toastActions.clearToastData
    }, dispatch);
}

export default connect(null, mapDispatchToProps)(Toast);



// WEBPACK FOOTER //
// ./components/toast/toast.js